// components/protected-routes/user-protected-route.jsx
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loader from "../common/Loader";
import { getDashboardStats } from "../../api/user/property/property";

const UserProtectedRoute = ({ children, onValidationChange, hideLoader = false }) => {
    const [isValidating, setIsValidating] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (onValidationChange) onValidationChange(true);
        validateToken();
    }, []);

    const validateToken = async () => {
        try {
            // Make API call to validate token via cookie
            const response = await getDashboardStats();
            if (response.success) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
            }
        } catch (error) {
            console.error('Token validation error:', error);
            setIsAuthenticated(false);
        } finally {
            setIsValidating(false);
            if (onValidationChange) onValidationChange(false);
        }
    };

    if (isValidating) {
        return hideLoader ? null : <Loader label="Checking your session..." />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
    }

    return children;
};

export default UserProtectedRoute;
